/** Leave native editor formatting and modal keyboard ownership intact. */
export const isAssistantShortcut = (event: KeyboardEvent) =>
  !event.defaultPrevented &&
  !event.repeat &&
  !event.altKey &&
  (event.ctrlKey || event.metaKey) &&
  event.key.toLowerCase() === 'i' &&
  !(
    event.target instanceof Element &&
    event.target.closest(
      'input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"]',
    )
  ) &&
  !document.querySelector('[role="dialog"]');
